module.exports = __webpack_public_path__ + "img/AW.4b84d8b5.svg";